import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoiceExport\InvoiceExportSalesJournal::__invoke
* @see app/Http/Controllers/InvoiceExport/InvoiceExportSalesJournal.php
* @route '/api/invoice/export/sales-journal'
*/
const InvoiceExportSalesJournal = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: InvoiceExportSalesJournal.url(options),
    method: 'post',
})

InvoiceExportSalesJournal.definition = {
    methods: ["post"],
    url: '/api/invoice/export/sales-journal',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\InvoiceExport\InvoiceExportSalesJournal::__invoke
* @see app/Http/Controllers/InvoiceExport/InvoiceExportSalesJournal.php
* @route '/api/invoice/export/sales-journal'
*/
InvoiceExportSalesJournal.url = (options?: RouteQueryOptions) => {
    return InvoiceExportSalesJournal.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoiceExport\InvoiceExportSalesJournal::__invoke
* @see app/Http/Controllers/InvoiceExport/InvoiceExportSalesJournal.php
* @route '/api/invoice/export/sales-journal'
*/
InvoiceExportSalesJournal.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: InvoiceExportSalesJournal.url(options),
    method: 'post',
})

export default InvoiceExportSalesJournal